module.exports = __webpack_public_path__ + "img/404.119817e6.png";